import { onScroll, scrollTop } from "../utils/scroll";

export function setupProductFloatingBar() {
  if(document.querySelector('.product-floating-bar') && document.getElementById('product-order-button')) {
    const bar = document.querySelector('.product-floating-bar');
    const btn = document.getElementById('product-order-button');
    const navHeight = parseInt(window.getComputedStyle(document.querySelector('.navigation'), ':before').getPropertyValue('height'));

    let triggerPoint = btn.offsetTop + btn.offsetHeight;

    if(navHeight) {
      triggerPoint = triggerPoint - navHeight;
    }

    onScroll(() => {
      if(scrollTop >= triggerPoint) {
        bar.classList.add('js-slide-up');
      } else {
        bar.classList.remove('js-slide-up');
      }
    })
  }
}